// NaN-safe display helpers for Grit. Note: Number(null) === 0, so guard nullish first.

function toNum(value) {
  if (value === null || value === undefined || value === '') return NaN;
  return Number(value);
}

export function fmtWeight(value) {
  const num = toNum(value);
  if (!Number.isFinite(num)) return '--';
  return `${num} lb`;
}

export function fmtReps(value) {
  const num = toNum(value);
  if (!Number.isFinite(num)) return '--';
  return `${num}`;
}

export function fmtMiles(value) {
  const num = toNum(value);
  if (!Number.isFinite(num)) return '--';
  return `${num.toFixed(2).replace(/\.?0+$/, '')} mi`;
}

// "8" when the range is one number (Cassidy's "8 reps each leg"), else "8–10".
export function repRange(lo, hi) { return lo === hi || hi == null ? `${lo}` : `${lo}–${hi}`; }
